export { default } from "./PostIndex";
